import { useParams } from "react-router-dom";
import { ProductOfferingConfigsPageView } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { ProductOfferingParams } from "src/routes/routesDef";

export function ProductOfferingConfigsPage() {
  const { developmentId, productOfferingId } = useParams<ProductOfferingParams>();
  return <ProductOfferingConfigsPageView marketsOrIds={{ developmentId, productOfferingId }} />;
}
